/* oxlint-disable grafit-oxlint/no-tailwind-font-classes -- Typography 2 migration */
import { iconVariants } from "@grafit/design-system/components/icons/variants-icon";
import { Trans, useTranslation } from "@grafit/i18n";
import { GlassesIcon } from "lucide-react";

export const NotFoundPage = ({ subtitle }: { subtitle?: string }) => {
  const { t } = useTranslation();

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-2">
      <GlassesIcon
        strokeWidth={0.96}
        className={iconVariants({
          size: "large-hero",
          className: "motion-safe:animate-[bounce_2000ms_ease-in-out_infinite]",
        })}
      />
      <h1 className="text-5xl">{t((r) => r["error.404.title"])}</h1>
      <div className="mt-12 flex flex-col items-center justify-center gap-3">
        <p className="max-w-md text-center">{subtitle ?? t((r) => r["error.404.subtitle"])}</p>
        <button
          onClick={(e) => {
            e.preventDefault();
            location.assign("/");
          }}
          type="button"
          className="underline hover:no-underline"
        >
          <Trans i18nKey="global.goToHomePage" />
        </button>
      </div>
    </div>
  );
};
